<template>
  <div>

    <div class="tabsBlock">
      <div v-for="(langName, lang) in activeLanguages" :key="lang">
        <div
          @click="() => {setTabLang(lang)}"
          :class="tabLang === lang ? 'tab__active' : 'tab'"
        >
          {{ langName }}
        </div>
      </div>
    </div>

    <div v-for="(langName, lang) in activeLanguages" :key="lang">
      <LangTab
        :visible="setLangToTab(lang)"
        :lang="lang"
        :name="langName"
        :description="langName"
      />
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import "./styles.scss"
import LangTab from "./Tab/index";
import {storeMixin} from "../../mixins/storeMixin";

const LANGUAGE_NAMES = {
  en: 'English',
  et: 'Estonian',
  ru: 'Russian',
  fi: 'Finnish',
  lv: 'Latvian',
  de: 'German',
  pl: 'Polish'
};

export default {
  mixins: [storeMixin],
  name: "LangTabsBlock",
  components: {
    LangTab
  },
  computed: {
    ...mapGetters({
      tabLang: 'tenants/ticketTypes/tabLang',
      kioskLanguages: 'kiosks/kiosk/kioskLanguages',
    }),
    activeLanguages() {
      const langs = this.kioskLanguages.length ? this.kioskLanguages : Object.keys(LANGUAGE_NAMES);
      return langs.reduce((acc, code) => {
        acc[code] = LANGUAGE_NAMES[code] || code;
        return acc;
      }, {});
    },
  },
  methods: {
    setLangToTab(lang) {
      return this.tabLang === lang ? 'block' : 'none'
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tenants/ticket-types/ui/LangTabsBlock/index.vue